<template>
  <generic-container
    :title="$t('student groups')"
    icon="users"
    :header_buttons="header_buttons"
  >
    <div>
      <draggable
        class="ui cards"
        :list="droppedGroups"
        group="groups"
        @add="onAdd"
      >
        <div class="card" v-for="(group, index) in droppedGroups" :key="index">
          <div class="content">
            <div class="header">{{ group.courseName }}</div>
            <div class="description">
              Estudiantes asignados: <b>{{ group.students }}</b>
            </div>
            <!-- <template v-if="group.type === 'group'">
              <div class="header">{{ group.courseName }}</div>
              <div class="description">
                Estudiantes asignados: <b>{{ group.students }}</b>
              </div>
            </template>
            <template v-else>
              <div class="header">
                {{ group.std_student.name }} -
                {{ group.std_student.student_id_card }}
              </div>
            </template> -->
          </div>
        </div>
      </draggable>
      <draggable
        class="ui cards"
        :list="droppedStudents"
        group="students"
        @add="onAdd"
      >
        <div
          class="card"
          v-for="(student, index) in droppedStudents"
          :key="index"
        >
          <div class="content">
            <div class="header">
              {{ student.std_student.name }} -
              {{ student.std_student.student_id_card }}
            </div>
            <div class="description">
              {{ student.std_studying_cycle.name }}
            </div>
          </div>
        </div>
      </draggable>
    </div>
  </generic-container>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import { enterprise_setup } from "@/utils";
import draggable from "vuedraggable";

export default {
  name: "StudentGroups",
  components: {
    "generic-container": GenericContainer,
    draggable,
  },
  filters: filters,
  data() {
    return {
      droppedGroups: [],
      droppedStudents: [],
      // droppedItems: [],
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    onAdd(event) {
      console.log("Added", event.item);
    },
    refresh() {
      let vm = this;
      vm.droppedGroups = [];
      vm.droppedStudents = [];
      // vm.droppedItems = [];
    },
  },
  mounted() {
    // let vm = this;
  },
};
</script>

<style>
/* Agrega aquí tus estilos personalizados */
</style>
